import Image from 'next/image';
import React from 'react';
import { useDispatch } from 'react-redux';
import image from '../../../../public/images/result-not-found.png';
import { setBasicFilters } from '@/redux/store/actions/search';
import { useRouter } from 'next/router';
import styles from './EmptyList.module.scss';
import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import Typography from '@/components/UI/typography/Typography';
const EmptyList = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const handleClick = () => {
    router.push(router.asPath.split('?')[0]);
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests: null
    }));
  };
  return <>
      <Box className={styles['empty-list-container']} data-sentry-element="Box" data-sentry-source-file="EmptyList.tsx">
        <Box className={styles['empty-list-box']} data-sentry-element="Box" data-sentry-source-file="EmptyList.tsx">
          <Box className={styles['empty-list-description']} data-sentry-element="Box" data-sentry-source-file="EmptyList.tsx">
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="EmptyList.tsx">
              نتیجه‌ای مطابق سلیقه شما پیدا نکردیم!
            </Typography>
            <Typography variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="EmptyList.tsx">
              برای مشاهده نتایج بیشتر، پیشنهاد می‌کنیم فیلترها را حذف کنید و یا
              در عبارتی که جستجو کردید بازنگری کنید.
            </Typography>
          </Box>
          <Box className={styles['empty-list-image']} data-sentry-element="Box" data-sentry-source-file="EmptyList.tsx">
            <Image src={image} alt="نتیجه‌ای یافت نشد" data-sentry-element="Image" data-sentry-source-file="EmptyList.tsx" />
          </Box>
          <Box className={styles['button-container']} data-sentry-element="Box" data-sentry-source-file="EmptyList.tsx">
            <Button format="tonal" onClick={handleClick} data-sentry-element="Button" data-sentry-source-file="EmptyList.tsx">
              حذف فیلترها
            </Button>
          </Box>
        </Box>
      </Box>
    </>;
};
export default EmptyList;